import { Panel, SimpleSlideShowProps } from '../types';

export function calculateTotalFrames(panels: Panel[], panelDurations: number[], fps: number = 30): number {
  // Total frames = sum of all panel durations (last panel already extended to audio duration)
  const total = panelDurations.reduce((sum, d) => sum + Math.ceil((d / 1000) * fps), 0);
  console.log('[videoUtils] calculateTotalFrames:', total, 'from durations:', panelDurations);
  return total;
}

export function calculateTotalDuration(panels: Panel[], panelDurations: number[]): number {
  return panelDurations.reduce((sum, d) => sum + d, 0) / 1000;
}

export function formatTime(seconds: number): string {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}

export function exportRenderConfig(
  panels: Panel[],
  panelDurations: number[],
  aspectRatio: '16:9' | '9:16' = '9:16'
) {
  return {
    compositionId: 'SimpleSlideshow',
    outputFormat: 'mp4',
    inputProps: {
      panels,
      panelDurations,
      aspectRatio,
      backgroundColor: '#000000',
      textColor: '#ffffff',
      showTitles: false,
      showCaptions: true,
    }
  };
}
